module.exports = __webpack_public_path__ + "static/media/m0x4_temp.f201f905.jpg";